/**
 * MUSKLE: Merken collection vendor facet hydration.
 *
 * Search & Discovery can expose filter.p.vendor while Shopify's full-document
 * storefront HTML for /collections/merken (nl-BE) remains a pre-enablement
 * snapshot. Section Rendering API already returns Merk/Brand correctly.
 *
 * If vendor inputs are missing on Merken, re-render the main section once with
 * cache bypass so native filter.p.vendor checkboxes appear.
 */
import { sectionRenderer } from '@theme/section-renderer';

const MERKEN_PATH = /\/collections\/merken\/?$/i;

function isMerkenCollectionPath(pathname) {
  return MERKEN_PATH.test(pathname || '');
}

function hasVendorFacetInputs() {
  return Boolean(document.querySelector('input[name="filter.p.vendor"]'));
}

function resolveSectionId() {
  const form = document.querySelector('facets-form-component[section-id]');
  return form?.getAttribute('section-id') || null;
}

async function hydrateMerkenVendorFacet() {
  if (!isMerkenCollectionPath(window.location.pathname)) return;
  if (hasVendorFacetInputs()) return;

  const sectionId = resolveSectionId();
  if (!sectionId) return;

  try {
    await sectionRenderer.renderSection(sectionId, { cache: false });
  } catch (error) {
    console.warn('[muskle] Merken vendor facet hydration failed', error);
  }
}

function scheduleHydration() {
  // Run after SectionRenderer's load-time DOM cache so we overwrite a stale snapshot.
  window.addEventListener(
    'load',
    () => {
      window.setTimeout(() => {
        hydrateMerkenVendorFacet();
      }, 0);
    },
    { once: true }
  );
}

scheduleHydration();
